
        export type PageLanguage = 'de' | 'fr' | 'it' | 'en'
        const VALID_LANGUAGES: PageLanguage[] = ["de","fr","it","en"]

        export function isValidLanguage(language: string): language is PageLanguage {
          return VALID_LANGUAGES.includes(language as any)
        }
        